import * as _ from "lodash";
var service = function($http) {
  var distributors = function(productLine, product) {
    return $http({
      method: 'GET',
      url: '/api/retailer/product_lines/' + productLine.id + '/distributors/',
      params: {
        product_line_id: productLine.id,
        product_id: _.get(product, 'id')
      }
    })
  };

  var selectDistributor = function(productLine, product, selectedDistributor) {
    return $http({
      method: 'POST',
      url: '/api/retailer/product_lines/' + productLine.id + '/distributor/',
      data: {
        product_id: (product || {}).id,
        distributor: {
          id: selectedDistributor.id
        }
      }
    })
  };

  return {
    distributors: distributors,
    selectDistributor: selectDistributor
  }
};
service.$inject = ['$http'];
tiz.service('RProductLine', service);
export default service;
